<template>
  <div class="t_content_view">
      <div class="t_search_box">
          <div class="t_search_select" style="margin-left: 20px;margin-right:20px">
              <span style="color: #6D6D6D;">起止时间检索：</span>
              <el-date-picker
                  size="small"
                  type="datetimerange"
                   v-model="sqtime.data"
                  @change="changesqTime"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  />
          </div>
          <div class="t_search_select" style="margin-left: 20px;margin-right:20px">
              <span style="color: #6D6D6D;">企业主体：</span>
              <el-select style="width: 180px;" v-model="searchdata.corp_ids" placeholder="选择主体" multiple>
                <el-option
                  v-for="(item,index) in allcomp.data"
                  :key="index"
                  :label="item.corp_name"
                  :value="item.id"
                />
              </el-select>
          </div>
          <el-button @click="restsearch" color="#F1F3F9" style="margin-bottom: 10px;" type="primary">重置</el-button>
          <el-button @click="searchbtn" color="#F1F3F9" style="margin-bottom: 10px;" type="primary">搜索</el-button>
          <el-button v-if="allstatus.data.export_status==0" @click="downloadall" class="t_add_people" color="#FF9A27" type="primary" >生成全部明细</el-button>
          <el-button  v-if="allstatus.data.export_status==1&&allstatus.data.export_url==''" type="primary" loading class="t_add_people" >生成中</el-button>
          <el-button v-if="allstatus.data.export_url" @click="downlink(allstatus.data.export_url)" type="primary" class="t_add_people" >全部明细下载</el-button>
      </div>

      <div style="display: flex;margin-bottom: 30px;margin-top: 20px;">
            <div class="t_tj_box">
                <div class="t_tj_box_num">{{ heji.data.num }}</div>
                <div class="t_tj_all">下单数</div>
            </div>
            <div class="t_tj_box">
                <div class="t_tj_box_num">{{ heji.data.userNum }}</div>
                <div class="t_tj_all">下单人数</div>
            </div>
            <div class="t_tj_box">
                <div class="t_tj_box_num">{{ heji.data.sendNum }}</div>
                <div class="t_tj_all">发货数</div>
            </div>
            <div class="t_tj_box">
                <div class="t_tj_box_num">{{ heji.data.repeatNum }}</div>
                <div class="t_tj_all">5天重复下单</div>
            </div>
        </div>


      


      <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.data" style="width: 100%;margin-top: 30px;">
          
          <el-table-column prop="name" label="客服名称" />
          <el-table-column prop="num" label="推送客户数" />
          <el-table-column prop="openNum" label="页面打开数" />
          <el-table-column prop="userNum" label="下单人数" />
          <el-table-column prop="orderNum" label="下单数" />
          <el-table-column prop="sendNum" label="发货数" />
          <el-table-column prop="repeatNum" label="5天重复下单数" />
          <el-table-column prop="activiNum" label="激活数" />
         
          <el-table-column label="操作">
              <template #default="scope">
                  <el-button v-if="scope.row.export_status==0" size="small" type="text" 
                  style="color:#4F46E5"
                  @click="downloaditem(scope.row.kfId)">生成订单明细</el-button>
                  <el-button v-if="scope.row.export_status==1&&scope.row.export_url==''" type="primary" loading>生成中</el-button>
                  <el-button  @click="downlink(scope.row.export_url)" v-if="scope.row.export_url" type="primary">点击下载</el-button>
              </template>
          </el-table-column>
      </el-table>
      <div style="display: flex;width: 100%;margin-top: 20px;">
        <div class="t_heji_itme" >合计：</div>
        <div class="t_heji_itme" >{{ heji.data.num }}</div>
        <div class="t_heji_itme" >{{ heji.data.openNum }}</div>
        <div class="t_heji_itme" >{{ heji.data.userNum }}</div>
        <div class="t_heji_itme" >{{ heji.data.orderNum }}</div>
        <div class="t_heji_itme" >{{ heji.data.sendNum }}</div>
        <div class="t_heji_itme" >{{ heji.data.repeatNum }}</div>
        <div class="t_heji_itme" >{{ heji.data.activiNum }}</div>
      
      </div>
      <!-- 分页 -->
      <!-- <pagechange :total="total" :nowpage="searchdata.pageNo" @page_change="page_change" /> -->
  </div>
 
</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch,inject, onBeforeUnmount} from 'vue'
//导入子组件
import pagechange from '../components/pagechange.vue'
import { ElMessage,ElMessageBox } from 'element-plus'
import { kflist ,getrecordlist,exportweapp,checkexportweapp,newgetshop,newcheckexportweapp,newexportweapp,newgetcomp2} from '@/assets/js/common.js'
//动态获取接口地址
const _url2 = inject('_url2')

const timebox = ref('')

onMounted(() => {
  console.log('onMounted')
  getDefaultTime()
  //获取列表
  getlist()
  //获取主体
  getcomplist()

  timebox.value = setInterval(() => {
    getlist()
    // console.log('定时器')
  }, 2000)

})

//全部主体
const allcomp = reactive({
    data:[]
})

//获取主体
const getcomplist = ()=>{
  newgetcomp2().then((response)=>{
    if (response.data.msg.code == 0) {
        console.log('获取主体')
        console.log(response)
        //添加全部主体
        // allcomp.data.push({
        //     id: 0,
        //     corp_name: "全部",
        // })
        //添加主体
        response.data.data.forEach(item => {
            allcomp.data.push({
                id: item.id,
                corp_name: item.corp_name,
            })
        });
    }
  })
}



//执行时间
const sqtime = reactive({
    data:[]
})
const getDefaultTime =  ()=> {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    //getCurrentTime方法见js方法中，中国标准时间转年月日时分秒
    sqtime.data[0]=getCurrentTime(start)
    sqtime.data[1]=getCurrentTime(end)
    searchdata.start_time =getCurrentTime(start) 
    searchdata.end_time = getCurrentTime(end)

}
//监听执行时间改变
const changesqTime = (e)=>{
    console.log(e)
    if(e==null){
        searchdata.start_time = ''
        searchdata.end_time = ''
    }else{
        searchdata.start_time = e[0]
        searchdata.end_time = e[1]
    }
}
//搜索
const searchdata = reactive({
 //当前页
  // pageNo:1,
  // pageSize:20,
  start_time:'',
  end_time:'',
  corp_ids:''
})

const restsearch = ()=>{
  searchdata.start_time = ''
  searchdata.end_time = ''
  searchdata.corp_ids = ''
  sqtime.data = []
  getDefaultTime()
}
const searchbtn = ()=>{
  // searchdata.pageNo = 1
  getlist()
}

//列表数据
const tableData = reactive({
  data:[]
})
//成员总数
const total = ref(0)

//全部-状态
const allstatus = reactive({
  data:{}
})

//合计
const heji = reactive({data:{
  num:0,
  openNum:0,
  userNum:0,
  orderNum:0,
  sendNum:0,
  repeatNum:0,
  activiNum:0,
}})
//获取列表
const getlist = ()=>{
  var obj = JSON.parse(JSON.stringify(searchdata));
    obj.corp_ids = obj.corp_ids.toString()
  newgetshop(obj).then((response)=>{
      if (response.data.msg.code == 0) {
          console.log('0000')
          console.log(response.data)
          tableData.data = response.data.data
          // total.value = response.data.result.total
          //合计
          let num = 0
          let openNum = 0
          let userNum = 0
          let orderNum = 0
          let sendNum = 0
          let repeatNum = 0
          let activiNum = 0
          response.data.data.forEach(item => {
            num += item.num
            openNum += item.openNum
            userNum += item.userNum
            orderNum += item.orderNum
            sendNum += item.sendNum
            repeatNum += item.repeatNum
            activiNum += item.activiNum
          })
          heji.data.num = num
          heji.data.openNum = openNum
          heji.data.userNum = userNum
          heji.data.orderNum = orderNum
          heji.data.sendNum = sendNum
          heji.data.repeatNum = repeatNum
          heji.data.activiNum = activiNum
      }
  })


  let curGoods = JSON.parse(JSON.stringify(obj));
  //给curGoods添加属性
  curGoods.type = 0
  newcheckexportweapp(curGoods).then((response)=>{
    if (response.data.msg.code == 0) {
        allstatus.data = response.data.data
       
    }
  })
}
//监听分页
const page_change = (val)=>{
  searchdata.pageNo = val
  //人员列表
  getlist()
}

//下载全部
const downloadall=  ()=>{
  newexportweapp({
    kfId:'',
    start_time:searchdata.start_time,
    end_time:searchdata.end_time,
    corp_ids:searchdata.corp_ids.toString()
  }).then((response)=>{
    if (response.data.msg.code == 0) {
       //获取列表
      getlist()
    }
  })
}

//下载订单明细
const downloaditem = (kfId)=>{
  newexportweapp({
    kfId:kfId,
    start_time:searchdata.start_time,
    end_time:searchdata.end_time,
    corp_ids:searchdata.corp_ids.toString()
  }).then((response)=>{
    if (response.data.msg.code == 0) {
       //获取列表
      getlist()
    }
  })
}

//下载链接
const downlink = (url)=>{
  const a = document.createElement('a');
    a.setAttribute('download', '');
    a.setAttribute('href', url);
    a.click();
}
//中国标准时间转化
    const getCurrentTime =  (date)=> {
    // let date = new Date()
    var year = date.getFullYear() //返回指定日期的年份
    var month = repair(date.getMonth() + 1);//月
    var day = repair(date.getDate());//日
    var hour = repair(date.getHours());//时
    var minute = repair(date.getMinutes());//分
    var second = repair(date.getSeconds());//秒
    
    //当前时间 
    var curTime = year + "-" + month + "-" + day+' ' + hour +':'+minute+':'+second;
    console.log(curTime)
    //返回 2022-11-25
    return curTime;
    }
    //补0
const repair = (i)=>{
    if (i >= 0 && i <= 9) {
        return "0" + i;
    } else {
        return i;
    }
}
onBeforeUnmount(() => {
  clearInterval(timebox.value)
})

</script>
<style scoped>


:deep( .el-input__wrapper ){
  background-color: #F1F3F9;
  box-shadow: 0 0 0 0 black;
}

.t_add_people {
  margin-bottom: 10px;
  color: white;
}

.t_head_box {
  display: flex;
  align-items: center;
}

/* .t_content_view {
  padding: 20px;
} */
.t_kf_jd_box{
  color: #017BFE;
  display: flex;
  align-items: center;
}
.t_heji_itme{
width: 11.11%;
padding-left: 1%;
box-sizing: border-box;
font-size: 17px;
color: #606266;
font-weight: bold;
}
.t_tj_box{
    width: 230px;
    height: 100px;
    border: 1px solid #CBD4E5;
    margin-right: 16px;
    background-color: #EDF3F8;
}
.t_tj_box_num{
    font-size: 29px;
    color: #144CFF;
    text-align: center;
    margin-top: 17px;
}
.t_tj_all{
    font-size: 15px;
    text-align: center;
}
:deep(.t_search_select .el-select__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
</style>